export class OrderSearchTypeConstants {
  public static readonly searchByCode = 'FILTER_BY_CODE';
  public static readonly searchByDate = 'FILTER_BY_DATE';

  public static readonly fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 14));
  public static readonly toDate: Date = new Date();
}
